export default "/_next/static/chunks/fonts/HK Grotesk Light-1b39df12af1aa94ea22c699528e9c7d8.otf";